import { ListViewSortDirection } from 'types/listViewColumns';

const getNextListViewSort = <TSortField extends string>(
  currentField: TSortField,
  currentDirection: ListViewSortDirection,
  clickedField: TSortField,
): { field: TSortField; direction: ListViewSortDirection } => {
  if (currentField === clickedField) {
    return {
      field: clickedField,
      direction: currentDirection === 'ASC' ? 'DESC' : 'ASC',
    };
  }
  return { field: clickedField, direction: 'DESC' };
};

export { getNextListViewSort };
